import React, { createContext, SetStateAction, Dispatch } from 'react';
import { Task } from '../ControllerTask/Details/Details.types';

export type MainCordovaContext = {
  toggleNavigation: (value?: boolean) => void;
};

export type BCContext = {
  task: Task | null;
  setTask: Dispatch<SetStateAction<Task | null>>;
};

export const mainCordovaContext = React.createContext<MainCordovaContext>({
  toggleNavigation: () => null,
});

export const bcContext = createContext<BCContext>({
  task: null,
  setTask: () => null,
});
